import { Button, Card, message } from "antd";
import React, { useEffect, useState } from "react";
import { API_METHODS, BLANK_VALUE } from "../../../constants";
import useApi from "../../../hooks/useApi";
import AddImages from "./AddImages";
import ReorderImagesModal from "./ReorderImagesModal";
import { arrayMove } from "@dnd-kit/sortable";
import DraggableTableContent from "../../common/DraggableTableContent";
function ImageTable() {
  const [visible, setVisible] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [visibleEdit, setVisibleEdit] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState();
  const [reorderImagesRecord, setReorderImagesRecord] = useState(null);
  const [messageApi, contextHolder] = message.useMessage();

  const keys = ["title"];
  const headers = ["Title"];

  const [responseData, getRequest] = useApi(
    `/admin/image`,
    null,
    API_METHODS.GET
  );
  const [deleteResponse, deleteRequest] = useApi();
  const [reorderResponse, reorderRequest] = useApi(
    `/admin/image/reorder`,
    null,
    API_METHODS.POST
  );
  const [reorderImagesResponse, reorderImagesRequest] = useApi();

  useEffect(() => {
    getRequest();
  }, []);

  useEffect(() => {
    if (reorderResponse?.data && !reorderResponse.isLoading) {
      getRequest();
    }
  }, [reorderResponse]);

  useEffect(() => {
    const data =
      responseData.data !== BLANK_VALUE && responseData.data !== null
        ? responseData.data
        : [];
    setTableData(data);
  }, [responseData]);

  useEffect(() => {
    if (deleteResponse.data && !deleteResponse.isLoading) {
      getRequest();
      messageApi.open({
        type: "success",
        content: "Images Deleted successfully",
      });
    }
  }, [deleteResponse]);

  useEffect(() => {
    if (reorderImagesResponse?.data && !reorderImagesResponse.isLoading) {
      setReorderImagesRecord(null);
      getRequest();
      messageApi.open({ type: "success", content: "Image order saved." });
    }
  }, [reorderImagesResponse]);

  const handleAddImages = (isUpdated) => {
    const flag = visible ? false : true;
    setVisible(flag);
    if (isUpdated === true) {
      getRequest();
    }
  };

  const handleEditImages = (isUpdated) => {
    const flag = visibleEdit ? false : true;
    !flag && setSelectedRecord(null);
    setVisibleEdit(flag);
    if (isUpdated === true) {
      getRequest();
    }
  };

  const editRecord = (record) => {
    setVisibleEdit(true);
    setSelectedRecord(record);
  };

  const deleteRecord = (record) => {
    deleteRequest(null, API_METHODS.DELETE, `/admin/image/${record.id}`);
  };

  const handleReorderImages = (record) => {
    setReorderImagesRecord(record);
  };

  const handleSaveImageOrder = (galleryId, newOrder) => {
    reorderImagesRequest(
      { new_order: newOrder },
      API_METHODS.POST,
      `/admin/image/${galleryId}/reorder-images`
    );
  };

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (active.id !== over.id) {
      const oldIndex = tableData.findIndex((text) => text.id === active.id);
      const newIndex = tableData.findIndex((text) => text.id === over.id);

      const newData = arrayMove(tableData, oldIndex, newIndex);
      setTableData(newData);
      let new_order = newData.map((item) => item.id);
      let data = { new_order };
      reorderRequest(data);
    }
  };

  return (
    <Card title="फोटो गॅलरी"
      extra={<Button type="primary" onClick={handleAddImages}>
        Add Images
      </Button>}>
      {contextHolder}

      <DraggableTableContent
        tableData={tableData}
        headers={headers}
        keys={keys}
        onDragEnd={handleDragEnd}
        onEdit={editRecord}
        onDelete={deleteRecord}
        onReorderImages={handleReorderImages}
      />

      {reorderImagesRecord && (
        <ReorderImagesModal
          record={reorderImagesRecord}
          saving={reorderImagesResponse?.isLoading}
          onClose={() => setReorderImagesRecord(null)}
          onSave={handleSaveImageOrder}
        />
      )}
      {visible && <AddImages visible={visible} close={handleAddImages} />}
      {visibleEdit && (
        <AddImages
          visible={visibleEdit}
          selectedRecord={selectedRecord}
          close={handleEditImages}
        />
      )}
    </Card>
  );
}

export default ImageTable;
